// @flow
import React, { type StatelessFunctionalComponent } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import configureStore from "./store";
import List from "../../components/MessagesList";
import Notification from "../../components/Notification";
import TableActions, { type TableActionsProps } from "../../containers/TablesActions";
import { MESSAGES_LIST_TABLE } from "../../helpers/constants";
import { changeIsActiveSaga, deleteSaga } from "../../actions/tableActions";

const actionsProps: TableActionsProps<typeof MESSAGES_LIST_TABLE> = {
  tableKey: MESSAGES_LIST_TABLE,
  editPath: "/messages/edit/:id",
  viewPath: "/messages/view/:id",
  clonePath: "/messages/clone/:id",
  onDelete: deleteSaga,
  onChangeIsActive: changeIsActiveSaga,
};

const MessagesList: StatelessFunctionalComponent<{}> = () => (
  <DocumentTitle title="Messages">
    <Provider store={configureStore()}>
      <List TableActions={<TableActions {...actionsProps} />} />
      <Notification />
    </Provider>
  </DocumentTitle>
);

export default MessagesList;
